import React from "react";
import ReactDOM from "react-dom";

let modalRootElement = document.getElementById("modal-root");
if (!modalRootElement) {
	modalRootElement = document.createElement("div");
	modalRootElement.setAttribute("id", "modal-root");
	document.body.appendChild(modalRootElement);
}

export default function Modal({ children }) {
	const modalContainer = React.useRef(document.createElement("div"));

	React.useLayoutEffect(() => {
		const currentEle = modalContainer.current;
		modalRootElement.appendChild(currentEle);

		return () => modalRootElement.removeChild(currentEle);
	}, []);

	return ReactDOM.createPortal(children, modalContainer.current);
}
